import * as ENUM from './enum'

const RES_ENUM = ENUM.RESULTADOS
const PROD_ENUM = ENUM.PRODUTOS

export {
  RES_ENUM,
  PROD_ENUM
}